import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
export function AddIcon(props) {
    const themeContext = useContext(ThemeContext);
    const { color = 'PrimaryDefault', secondaryColor = 'White', ...rest } = props;
    const primaryFillColor = themeContext.colors[color];
    const secondaryFillColor = themeContext.colors[secondaryColor];
    return (_jsxs("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...rest, children: [_jsx("circle", { cx: 12, cy: 12, r: 9, fill: secondaryFillColor }), _jsx("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2 12C2 6.477 6.477 2 12 2c5.516.016 9.984 4.484 10 10 0 5.523-4.477 10-10 10S2 17.523 2 12zm10.833.833H17v-1.666h-4.167V7h-1.666v4.167H7v1.666h4.167V17h1.666v-4.167z", fill: primaryFillColor })] }));
}
//# sourceMappingURL=Add.js.map